import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { MUITheme } from 'styles'
import configureStore from 'store'
import { Auth0LockProvider } from 'components/Auth/useAuth0'
import { Provider as ReduxProvider } from 'react-redux'
import AlertsProvider from './AlertsProvider'

const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <MuiThemeProvider theme={MUITheme}>
      <CssBaseline />
      <ReduxProvider store={configureStore()}>
        <Auth0LockProvider>
          <AlertsProvider>{children}</AlertsProvider>
        </Auth0LockProvider>
      </ReduxProvider>
    </MuiThemeProvider>
  )
}

export default AppProvider
